import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { getInterestOptions, OTHER_INTEREST } from '../../data/quizOptions';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
interface StepInterestsProps extends StepProps {
  customInterest: string;
  onCustomInterestChange: (value: string) => void;
}
export function StepInterests({
  profile,
  update,
  onNext,
  customInterest,
  onCustomInterestChange
}: StepInterestsProps) {
  const options = getInterestOptions(profile.child_gender);
  const showCustom = profile.child_interests.includes(OTHER_INTEREST);
  const canContinue = profile.child_interests.length > 0 && (!showCustom || customInterest.trim().length > 0);
  return <div className="flex flex-1 flex-col" data-id="element-119" data-mp="3lt103on6cgwb">
      <Headline data-id="element-120" data-mp="3luvhisz8lqvn">¿Qué cosas le encantan a {profile.child_name}? ✨</Headline>
      <Subtext data-id="element-121" data-mp="3h1j7poz7vomy">Puedes elegir varias opciones.</Subtext>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-122" data-mp="3h0r9s7i5deti">
        {options.map(option => <ChoiceChip key={option.label} emoji={option.emoji} label={option.label} selected={profile.child_interests.includes(option.label)} onSelect={() => update({
        child_interests: toggleValue(profile.child_interests, option.label)
      })} data-id="element-123" data-mp="3c1em5kjgc3pv" />)}
      </div>

      <AnimatePresence initial={false} data-id="element-124" data-mp="3vqf9x5ele7fn">
        {showCustom && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-125" data-mp="3qsnjkftlitdk">
            <div className="pt-5" data-id="element-126" data-mp="2ffbddyad5yo8">
              <TextAreaField id="custom-interest" label="Cuéntanos qué le encanta" rows={3} value={customInterest} onChange={onCustomInterestChange} placeholder="Le fascinan los trenes antiguos" data-id="element-127" data-mp="2gunlrxzi9ayw" />
            </div>
          </motion.div>}
      </AnimatePresence>

      <div className="mt-auto pt-10" data-id="element-128" data-mp="2bx5h4jsithwp">
        <PrimaryButton onClick={onNext} disabled={!canContinue} data-id="element-129" data-mp="1y3mp5gluxrii">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}